import { Link } from "react-router-dom";
import { SiYoutube, SiInstagram, SiTiktok } from "react-icons/si";
import { SITE } from "@/data/site";

const socialLinks = [
  { key: "youtube", href: SITE.socials.youtube, Icon: SiYoutube, label: "YouTube" },
  { key: "instagram", href: SITE.socials.instagram, Icon: SiInstagram, label: "Instagram" },
  { key: "tiktok", href: SITE.socials.tiktok, Icon: SiTiktok, label: "TikTok" },
];

export const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-ink text-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-20 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-12">
          <div>
            <a
              href={`mailto:${SITE.email}`}
              data-testid="footer-email"
              className="inline-block text-lg md:text-xl text-cream/80 hover:text-cream border-b border-cream/30 hover:border-cream transition-colors duration-300"
            >
              {SITE.email}
            </a>
          </div>

          <div className="flex gap-5">
            {socialLinks.map(({ key, href, Icon, label }) => (
              <a
                key={key}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                data-testid={`footer-social-${key}`}
                className="h-12 w-12 rounded-full border border-cream/20 flex items-center justify-center text-cream/80 hover:bg-cream hover:text-ink transition-all duration-300"
              >
                <Icon size={20} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/15 flex flex-col sm:flex-row justify-between gap-4 text-sm text-cream/50">
          <span>© {new Date().getFullYear()} {SITE.name} · {SITE.domain}</span>
          <div className="flex gap-6">
            <Link to="/about" className="hover:text-cream transition-colors">About</Link>
            <Link to="/portfolio" className="hover:text-cream transition-colors">Videos</Link>
            <Link to="/contact" className="hover:text-cream transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
